import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import OdpdSaveButton from "./OdpdSaveButton"
import classes from "./OdpdFooter.module.scss"

const OdpdFooter = props => {
  const {
    form,
    setForm,
    order,
    setOrders,
    enableEdit,
    setEnableEdit
  } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)

  const handleEnableEdit = () => {
    setEnableEdit(true)

    setForm({
      paymentNote: order.paymentNote || "",
      paymentAttachUrls: order.paymentAttachUrls
    })
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["row"]}>
      {enableEdit
        ?
        <Fragment>
          <Button
            disabled={sending}
            onClick={() => setEnableEdit(false)}
            color="danger"
            className={clsx(
              classes["button"],
              isLtr && classes["button-ltr"]
            )}
          >
            {t("بازگشت")}
          </Button>

          <OdpdSaveButton
            form={form}
            order={order}
            setOrders={setOrders}
            sending={sending}
            setSending={setSending}
            setEnableEdit={setEnableEdit}
          />
        </Fragment>
        :
        <Button
          onClick={handleEnableEdit}
          color="warning"
        >
          {t("ویرایش")}
        </Button>}
    </div>
  )
}

export default OdpdFooter